class Video {
  constructor({ id, attributes: { mime, url } }) {
    this.id = id;
    this.mime = mime;
    this.url = url;
  }
}

export default Video;
